import { Injectable } from "@angular/core";
import { Http, Response  } from "@angular/http";
import { Observable } from "rxjs/Observable";
import { ConfigurationReaderBase } from "./ConfigurationReader";
import { Lookup } from "../model/Lookup";
import { EntityLookupSearchCriteria, EntityLookupSearchResult } from "../model/ReportingEntityLookupSearchCriteria";
import { AuthenticationBase } from "./Authentication";
import { HttpUtility } from "./HttpUtility";
import { User } from "../model/User";
import { QueryStringBuilder } from "./QueryStringBuilder";
import { ChangePassword } from "../../Home/model/ChangePassword";
import { Application } from "../model/Application";
import { ChangePasswordResult } from "../../Home/model/ChangePasswordResult";

@Injectable()
export abstract class CommonServiceBase{
    constructor(protected http:Http, protected configurationReader: ConfigurationReaderBase, protected authentication:AuthenticationBase) {}
    abstract getJurisdiction(): Observable<Lookup[]>;
    abstract search(criteria: EntityLookupSearchCriteria): Observable<EntityLookupSearchResult>;
    abstract getCurrentUserInfo(): Observable<User>;
    abstract changePassword(changePassword: ChangePassword): Observable<ChangePasswordResult>;
    abstract getPasswordRules():Observable<Array<string>>;
    abstract getUserApplication(): Observable<Application>;
}

@Injectable()
export class CommonService extends CommonServiceBase{

    constructor(protected http:Http, protected configurationReader: ConfigurationReaderBase, protected authentication:AuthenticationBase, 
                protected httpUtility: HttpUtility) {
        super(http, configurationReader, authentication);
    }

    getJurisdiction(): Observable<Lookup[]> {
        let url = this.configurationReader.Configuration.apiBaseUrl + "common/GetJurisdiction";
        return this.http.get(url, this.authentication.getAuthenticationHeader())
        .map((r)=><Lookup[]>r.json())
        .catch(this.httpUtility.handleError);
    }

    search(criteria: EntityLookupSearchCriteria): Observable<EntityLookupSearchResult> {

        let url = this.configurationReader.Configuration.apiBaseUrl + "common/Search";
        return this.http.post(url, criteria, this.authentication.getAuthenticationHeader())
        .map((r)=><EntityLookupSearchResult>r.json())
        .catch(this.httpUtility.handleError);
    }

    getCurrentUserInfo(): Observable<User>{

        let url = this.configurationReader.Configuration.apiBaseUrl + "common/userinfo";
        return this.http.get(url, this.authentication.getAuthenticationHeader())
        .map((r)=><User>r.json())
        .catch(this.httpUtility.handleError);
    }

    changePassword(changePassword: ChangePassword): Observable<ChangePasswordResult>{

        let baseUrl = this.configurationReader.Configuration.apiBaseUrl;
        let options= this.authentication.getAuthenticationHeader();
        let params = QueryStringBuilder.BuildParametersFromSearch<ChangePassword>(changePassword);
        options.params = params;

        return this.http.get(baseUrl + 'Security/ChangePassword', options)
               .map((r)=><ChangePasswordResult>r.json())
               .catch(this.httpUtility.handleError);
    }

    getPasswordRules():Observable<Array<string>>{

        let url = this.configurationReader.Configuration.apiBaseUrl + "Security/GetPasswordRules";
        return this.http.get(url, this.authentication.getAuthenticationHeader())
        .map((r)=><Array<string>>r.json())
        .catch(this.httpUtility.handleError);
    }

    getUserApplication(): Observable<Application>{

        let url = this.configurationReader.Configuration.apiBaseUrl + "common/application";
        return this.http.get(url, this.authentication.getAuthenticationHeader())
        .map((r)=><Application>r.json())
        .catch(this.httpUtility.handleError);
    }
}


// WEBPACK FOOTER //
// C:/TeamCity/buildAgent/work/4b34a5ca2bd08993/UI/rp/src/app/Shared/service/CommonService.ts